import { KYMW0C00Component } from './kymw0c00.component';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { KYMW0E00InputModel } from '../../kymw0e/kymw0e00/vo/kymw0e00-input.model';
import { KYMW0C00InputModel } from './vo/kymw0c00-input.model';
import { ImageInstructListRowModel } from './vo/image-instruct-list-row.model';
import { ReferenceImageList } from './vo/reference-image-list.model';
import { ReferenceImageDeleteList } from './vo/reference-image-delete-list.model';

/**
 * 画像作成指示画面の値を管理するクラス
 *
 * @export KYMW0C00Model
 * @class KYMW0C00Model
 */
export class KYMW0C00Model {

  kymw0C00Component: KYMW0C00Component;

  /** 画像ID */
  public imageID: string = null;

  // 共通部バインドデータ
  /** 使用開始受注コード */
  public startOrderCode: string = <string>'';
  /** 使用終了受注コード */
  public endOrderCode: string = <string>'';
  /** 使用開始配達企画回(翌週) */
  /** 使用終了配達企画回(翌週) */
  /** 無期限 */
  public endOrderNothing: boolean = <boolean>true;
  /** 所属 */
  public imageBelongID: string = <string>'';
  /** 今回のみ */
  public endOrderEqual: boolean = <boolean>false;
  /** eフレンズ */
  public eFriends: boolean = <boolean>false;
  /** Ｐコード */
  public pCode: string = <string>'';
  /** 商品案内用商品名 */
  public guideGoodsName: string = <string>'';
  /** 商品案内用商品名 */
  public guideStandardName: string = <string>'';
  /** 撮影予定日 */
  public photoSchedule: string = <string>'';
  /** 撮影場所 */
  public photoStudioID: string = <string>'';
  /** サンプル発注先コード */
  public sampleOrderingCode: string = <string>'';
  /** サンプル発注先コード名 */
  public sampleSupplierNameKanji: string = <string>'';
  /** 請求先コード */
  public billingCode: string = <string>'';
  /** 請求先コード名 */
  public billingSupplierNameKanji: string = <string>'';
  /** 請求対象 */
  public billingTargetDiv: boolean = <boolean>false;
  /** メモ */
  public memo: string = <string>'';

  // 詳細部バインドデータ
  /* 画像名 */
  public imageName: string = <string>'';
  /** 画像ファイル名 */
  public imageFileName: string = <string>'';
  /** 画像種別 */
  public imageType: string = <string>'';
  /** ステータス */
  public statusName: string = <string>'';
  /** 画像種類 */
  public imageKind: string = <string>'';
  /** 調理分類 */
  public cookingDiv: string = <string>'';
  /** 調理指示 */
  public processInstruct: string = <string>'';
  /** 調理例掲載区分 */
  public cookingExPublish: boolean = <boolean>false;
  /** 料理名 */
  public cookingName: string = <string>'';
  /** 材料名 */
  public materialName: string = <string>'';
  /** キーワード */
  public keyWord: string = <string>'';
  /** 画像キャプション */
  public textCaption: string = <string>'';
  /** 掲載指示内容 */
  public photoInstructContents: string = <string>'';
  /** 備考 */
  public remarks: string = <string>'';
  /** 撮影内容区分 */
  public photoContentsDiv: string = <string>'';
  /** 季節・催事 */
  public eventID: string = <string>'';
  /** 複数コード */
  public multipleCode: string = <string>'';
  /** プロモーション */
  public promotionFlg: boolean = <boolean>false;
  /** サンプル数量 */
  public sampleNum: string = <string>'';
  /** 皿盛・ザル盛_皿の色変更（基本はイメージ）*/
  public colorChange: string = <string>'';
  /** 調理要/調理不要_断面 */
  public crossSection: boolean = <boolean>false;
  /** 調理不要_撮影演出 */
  public photoRenditionCookUnnecessary: boolean = <boolean>false;

  // ラジオボタンデータ
  /** 包材_撮影 */
  public shooting: string = <string>'';
  public grp_Shooting: string = <string>'';
  /** 包材_撮影/外包材と個包材 */
  public shootingPackageText: string = <string>'';
  /** 包材_撮影角度(面) */
  public shootingAngle: string = <string>'';
  public grp_ShootingAngle: string = <string>'';
  /** 包材_並べ方 */
  public alignment: string = <string>'';
  public grp_Alignment: string = <string>'';
  /** 包材_並べ方/横並 */
  public alignmentHorizontal: string = <string>'';
  /** 包材_並べ方/縦並 */
  public alignmentVertical: string = <string>'';
  /** 皿盛・ザル盛_器 */
  public vesselPlating: string = <string>'';
  public grp_VesselPlating: string = <string>'';
  /** 皿盛・ザル盛_盛り方 */
  public plating: string = <string>'';
  public grp_Plating: string = <string>'';
  /** 皿盛・ザル盛_添え物 */
  public accompaniments: string = <string>'';
  public grp_Accompaniments: string = <string>'';
  /** 調理要_数量 */
  public qtyCookNecessary: string = <string>'';
  public grp_QtyCookNecessary: string = <string>'';
  /** 調理要_数量/個数 */
  public qtyCookNecessaryNum: string = <string>'';
  /** 調理要_数量/器数 */
  public qtyCookNecessaryVesselNum: string = <string>'';
  /** 調理要_器形状 */
  public vesselShapeCookNecessary: string = <string>'';
  public grp_VesselShapeCookNecessary: string = <string>'';
  /** 調理要_器 */
  public vesselCookNecessary: string = <string>'';
  public grp_VesselCookNecessary: string = <string>'';
  /** 調理要_イメージ */
  public photoImageCookNecessary: string = <string>'';
  public grp_PhotoImageCookNecessary: string = <string>'';
  /** 調理要_撮影演出 */
  public photoRenditionCookNecessary: string = <string>'';
  public grp_PhotoRenditionCookNecessary: string = <string>'';
  /** 調理不要_数量 */
  public qtyCookUnnecessary: string = <string>'';
  public grp_QtyCookUnnecessary: string = <string>'';
  /** 調理不要_数量/個数 */
  public qtyCookUnnecessaryNum: string = <string>'';
  /** 調理不要_数量/器数 */
  public qtyCookUnnecessaryVesselNum: string = <string>'';
  /** 調理不要_器形状 */
  public vesselShapeCookUnnecessary: string = <string>'';
  public grp_VesselShapeCookUnnecessary: string = <string>'';
  /** 調理不要_器 */
  public vesselCookUnnecessary: string = <string>'';
  public grp_VesselCookUnnecessary: string = <string>'';
  /** 調理不要_イメージ */
  public photoImageCookUnnecessary: string = <string>'';
  public grp_PhotoImageCookUnnecessary: string = <string>'';
  /** 説明・素材_切抜 or 角版 */
  public cropExistenceType: string = <string>'';
  public grp_CropExistenceType1: string = <string>'';
  public grp_CropExistenceType2: string = <string>'';

  // 参考資料画像
  public referenceImageList: Array<ReferenceImageList> = new Array<ReferenceImageList>();
  public workReferenceImageDeleteList: Array<ReferenceImageDeleteList> = new Array<ReferenceImageDeleteList>();
  public referenceImageDeleteList: Array<ReferenceImageDeleteList> = new Array<ReferenceImageDeleteList>();

  // 活性・非活性制御用バインドデータ
  /** 使用開始受注コード 活性フラグ */
  public startOrderCodeEnabled: boolean = <boolean>true;
  /** 使用終了受注コード 活性フラグ */
  public endOrderCodeEnabled: boolean = <boolean>false;
  /** 無期限 活性フラグ */
  public endOrderNothingEnabled: boolean = <boolean>true;
  /** 所属 活性フラグ */
  public imageBelongIdEnabled: boolean = <boolean>true;
  /** 画像種別 活性フラグ */
  public imageTypeEnabled: boolean = <boolean>true;
  /** Pコード 活性フラグ */
  public pCodeEnabled: boolean = <boolean>true;
  /** 調理指示 活性フラグ */
  public processInstructEnabled: boolean = <boolean>false;

  /** 画像個別項目 新規ボタン 活性フラグ */
  public btnNewImageEnabled: boolean = <boolean>true;
  /** 画像個別項目 更新ボタン 活性フラグ */
  public btnSettingEnabled: boolean = <boolean>true;

  /** 新規ボタン */
  public btnNewEnabled: boolean = <boolean>true;
  /** 更新ボタン */
  public btnUpdateEnabled: boolean = <boolean>true;
  /** 出力ボタン 活性フラグ */
  public btnOutputEnabled: boolean = <boolean>true;

  /** 外包材と個包装テキスト 活性フラグ */
  public shootingPackageTextEnabled: boolean = <boolean>false;
  /** 横並テキスト 活性フラグ */
  public alignmentHorizontalEnabled: boolean = <boolean>false;
  /** 縦並テキスト 活性フラグ */
  public alignmentVerticalEnabled: boolean = <boolean>false;
  /** 調理要_数量/個数テキスト 活性フラグ */
  public qtyCookNecessaryNumEnabled: boolean = <boolean>false;
  /** 調理要_数量/器数テキスト 活性フラグ */
  public qtyCookNecessaryVesselNumEnabled: boolean = <boolean>false;
  /** 調理不要_数量/個数テキスト 活性フラグ */
  public qtyCookUnnecessaryNumEnabled: boolean = <boolean>false;
  /** 調理不要_数量/器数テキスト 活性フラグ */
  public qtyCookUnnecessaryVesselNumEnabled: boolean = <boolean>false;
  /** 切抜or角版 活性フラグ */
  public cropExistenceTypeEnabled: boolean = <boolean>false;
  /** 参考資料画像撮影指示内容 活性フラグ */
  public referenceImagePhotoContentsDivEnabled: boolean = <boolean>true;

  // 画像作成リスト部バインドデータ
  /** 画像作成指示リスト */
  public imageInstructList: Array<ImageInstructListRowModel> = new Array<ImageInstructListRowModel>();

  // 共通情報
  public ImageGroupNO: string = <string>'';
  public imageTypeList: Array<any> = [];

  // 一覧から選択したイメージID
  public imageId: string = <string>'';
  public status: string = <string>'';

  /** 画面全体変更フラグ */
  public changeAllFlg: boolean;
  /** 画面詳細変更フラグ */
  public changeDetailFlg: boolean;

  /** 編集状態(1:登録 , 2:編集) */
  public editMode = String('1');
  /** 変更前_使用開始受注コード */
  public beforeStartOrderCode: string = <string>'';
  /** 変更後_使用終了受注コード */
  public beforeEndOrderCode: string = <string>'';

  // 権限情報:参照権限フラグ
  public funcPermissionViewer: boolean = <boolean>false;

  /** 撮影注意事項表示・非表示ステータス */
  public imageTypeStatusVisible: string = <string>'';

  /* 画像情報管理の取得 */
  public setImageGroupInfo(serverData: any): void {
    this.ImageGroupNO = serverData.ImageGroupNo;
    this.startOrderCode = serverData.StartOrderCode;
    this.endOrderCode = serverData.EndOrderCode;

    // 変更後にも同時に設定しておく
    this.beforeStartOrderCode = serverData.StartOrderCode;
    this.beforeEndOrderCode = serverData.EndOrderCode;

    this.eFriends = PlessViewUtilsSub.StringTOBoolean(serverData.EFriendsProduct);
    this.pCode = serverData.PCode;
    this.guideGoodsName = serverData.GuideGoodsName;
    this.guideStandardName = serverData.GuideStandardName;
    this.photoSchedule = PlessViewUtilsSub.editDate(serverData.PhotoSchedule, '2');
    this.sampleOrderingCode = serverData.SampleOrderingCode;
    this.sampleSupplierNameKanji = serverData.SampleSupplierNameKanji;
    this.billingCode = serverData.BillingCode;
    this.billingSupplierNameKanji = serverData.BillingSupplierNameKanji;
    this.billingTargetDiv = PlessViewUtilsSub.StringTOBoolean(serverData.BillingTargetDiv);
    this.imageBelongID = serverData.ImageBelongID;
    this.photoStudioID = serverData.PhotoStudioID;
    this.memo = serverData.Memo;
    this.imageKind = serverData.ImageKind;

    // 画像作成指示リスト
    this.imageInstructList = ImageInstructListRowModel.create(serverData.ImageInfoList);

    // データ設定後処理
    if (this.endOrderCode === '9999999' || this.startOrderCode === this.endOrderCode) {
      this.endOrderCodeEnabled = false;
      if (this.endOrderCode === '9999999') {
        this.endOrderCode = '';
        this.endOrderNothing = true;
      } else {
        this.endOrderCode = serverData.EndOrderCode;
        this.endOrderNothing = false;
      }
    } else {
      this.endOrderCodeEnabled = true;
      this.endOrderCode = serverData.EndOrderCode;
      this.endOrderNothing = false;
    }

    this.endOrderCode = this.endOrderCode;
    if (this.startOrderCode === null || PlessViewUtilsSub.isEmpty(this.startOrderCode)) {
      // 使用開始受注コードがNULLもしくは空の場合、「無制限」にチェック
      this.endOrderNothing = true;
    } else {
      // 使用開始受注コード＝使用終了受注コードの場合、「今回のみ」にチェック
      this.endOrderEqual = (this.startOrderCode === this.endOrderCode) ? true : false;
    }

    this.imageBelongIdEnabled = false;
    this.pCodeEnabled = false;
    this.btnOutputEnabled = true;
    this.changeAllFlg = false;
    this.changeDetailFlg = false;
  }

  /* Ｐコード取得 */
  public setPCode(serverData: any): void {
    // ・該当コードが存在する場合は、「商品案内用商品名」「商品案内用規格名」を表示する。
    // ・Ｐコードに対応する「発注先取引先コード」を画面項目「サンプル発注先コード」に表示する。
    // ・画面項目「サンプル発注先コード」に対応する取引先名称を画面項目「サンプル発注先名称」に
    // 　表示する。
    // ・Ｐコードに対応する「支払先取引先コード」を画面項目「請求先コード」に表示する。
    // ・画面項目「請求先コード」に対応する取引先名称を画面項目「請求先名称」に表示する。
    if (serverData.AdmitStatus !== '2') {
      this.kymw0C00Component.dialogService.openAlertGetMessage('E0207', ['Pコード', '「2：本登録」前', '画像作成指示']);
    }

    this.guideGoodsName = serverData.GuideGoodsName;
    this.guideStandardName = serverData.GuideStandardName;
    this.sampleOrderingCode = serverData.SampleOrderingCode;
    this.sampleSupplierNameKanji = serverData.SampleSupplierNameKanji;
    this.billingCode = serverData.BillingCode;
    this.billingSupplierNameKanji = serverData.BillingSupplierNameKanji;

    // Pコードにフォーカス
    if (this.pCodeEnabled) {
      //   this.pCode.setFocus();
      document.getElementById('txti_PCode').focus();
    }
  }

  /* 取引先名称取得 */
  public setSampleOrderingSupplierName(serverData: any): void {
    this.sampleSupplierNameKanji = serverData.SupplierNameKanji;
    document.getElementById('txti_SampleOrderingCode').focus();
  }

  /* 取引先名称取得 */
  public setBillingCodeSupplierName(serverData: any): void {
    this.billingSupplierNameKanji = serverData.SupplierNameKanji;
    document.getElementById('txti_BillingCode').focus();
  }

  /* 画像情報管理の取得 */
  public getImageTypeLimit(serverData: any): void {
    this.imageTypeList = serverData;
  }

  /** 画像情報管理の更新 */
  public setUpdateImageInfo(serverData: any): void {
    if (!PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.nullToBlank(serverData.Code))) {
      const inputVo: KYMW0E00InputModel = new KYMW0E00InputModel();
      if (serverData.Code === 'E0199') {
        // 画像ID
        const imageId = serverData.ImageID;
        const imageInfo = this.kymw0C00Component.getImageInfo(imageId);
        // メッセージコードが「E0199(使用ページ確認、受注コード変更エラー)」の場合
        inputVo.processDiv = 1;
        inputVo.startOrderCodeBefore = this.beforeStartOrderCode;  // 変更前_使用開始受注コード
        inputVo.endOrderCodeBefore = this.beforeEndOrderCode;   // 変更前_使用終了受注コード
        inputVo.startOrderCodeAfter = this.startOrderCode;      // 変更後_使用開始受注コード
        inputVo.endOrderCodeAfter = this.endOrderCode;          // 変更後_使用終了受注コード
        inputVo.imageID = imageId;                              // 画像ID(メッセージ部に格納)
        inputVo.imageFileName = imageInfo.ImageFileName;        // 画像ファイル名(画像IDからデータ取得)
        inputVo.imageName = imageInfo.ImageName;                // 画像名(画像IDからデータ取得)
        // 使用ページ確認(受注コード変更)を呼び出す
        this.kymw0C00Component.openUsePageCheck(inputVo);
      } else if (serverData.Code === 'E0200') {
        // 画像ID
        const imageId = serverData.ImageID;
        const imageInfo = this.kymw0C00Component.getImageInfo(imageId);
        // メッセージコードが「E0200(使用ページ確認、削除エラー)」の場合
        inputVo.processDiv = 3;
        inputVo.imageID = imageId;          // 画像ID(メッセージ部に格納)
        inputVo.imageFileName = imageInfo.ImageFileName;    // 画像ファイル名(画像IDからデータ取得)
        inputVo.imageName = imageInfo.ImageName;      // 画像名(画像IDからデータ取得)
        // 使用ページ確認(削除)を呼び出す
        this.kymw0C00Component.openUsePageCheck(inputVo);
      } else {
        // 確認メッセージを表示
        this.kymw0C00Component.dialogService.openAlertGetMessage(serverData.Code, [serverData.Msg], () => {
          this.setUpdateImageInfoConfirm(serverData);
        });
      }

    } else {
      this.setUpdateImageInfoConfirm(serverData);
    }
  }

  /* 画像情報管理の更新 */
  private setUpdateImageInfoConfirm(serverData: any): void {
    this.clearImageInfoHead();
    this.clearImageInfoDetail();

    // 画面活性・非活性設定
    this.endOrderCodeEnabled = false;
    this.endOrderNothingEnabled = true;
    this.pCodeEnabled = true;
    this.imageBelongIdEnabled = true;
    this.imageTypeEnabled = true;
    this.btnOutputEnabled = false;
    this.btnSettingEnabled = true;

    this.imageTypeEnabled = true;
    if (!PlessViewUtilsSub.isEmpty(serverData.ImageID)) {
      this.kymw0C00Component.inputParam.ImageID = serverData.ImageID;
      this.kymw0C00Component.eventSendGetImageGroupInfoEvent(serverData.ImageID);
      this.editMode = '2';
    } else {
      // インプットパラメータ初期化
      this.kymw0C00Component.inputParam = new KYMW0C00InputModel();
      // 登録モード
      this.editMode = '1';
    }
    this.referenceImageDeleteList = new Array<ReferenceImageDeleteList>();
  }

  /* 画像共通情報をクリアする */
  public clearImageInfoHead(): void {
    // 画面情報初期化
    this.startOrderCode = '';
    this.endOrderCode = '';
    this.endOrderNothing = true;
    this.endOrderEqual = false;
    this.eFriends = false;
    this.imageBelongID = '';
    this.pCode = '';
    this.sampleOrderingCode = '';
    this.billingCode = '';
    this.sampleSupplierNameKanji = '';
    this.billingSupplierNameKanji = '';
    this.guideGoodsName = '';
    this.guideStandardName = '';
    this.photoSchedule = '';
    this.photoStudioID = '';
    this.billingTargetDiv = false;
    this.memo = '';
    this.imageKind = '';

    // バインドデータ初期化
    this.ImageGroupNO = '';
    this.startOrderCode = '';
    this.endOrderCode = '';
    this.endOrderNothing = true;
    this.endOrderEqual = false;
    this.eFriends = false;
    this.pCode = '';
    this.guideGoodsName = '';
    this.guideStandardName = '';
    this.photoSchedule = '';
    this.sampleOrderingCode = '';
    this.sampleSupplierNameKanji = '';
    this.billingCode = '';
    this.billingSupplierNameKanji = '';
    this.billingTargetDiv = false;
    this.memo = '';
    this.imageInstructList = new Array<ImageInstructListRowModel>();

    // 変更前の受注コードをクリア
    this.beforeStartOrderCode = '';
    this.beforeEndOrderCode = '';

    // 変更フラグ初期化
    this.changeAllFlg = false;
  }

  /* 画像詳細情報をクリアする */
  public clearImageInfoDetail(): void {
    this.imageType = '';
    this.processInstruct = '';
    this.processInstructEnabled = false;
    this.status = '';
    this.cookingExPublish = false;
    this.cookingDiv = '';
    this.eventID = '';
    this.photoContentsDiv = '';
    this.imageId = '';
    this.imageName = '';
    this.imageFileName = '';
    this.statusName = '';
    this.cookingExPublish = false;
    this.cookingName = '';
    this.materialName = '';
    this.keyWord = '';
    this.textCaption = '';
    this.photoInstructContents = '';
    this.remarks = '';
    this.multipleCode = '';
    this.sampleNum = '';
    this.promotionFlg = false;
    this.imageTypeStatusVisible = '';
    this.colorChange = '';
    this.crossSection = false;
    this.photoRenditionCookUnnecessary = false;
    this.shooting = '';
    this.grp_Shooting = '';
    this.shootingPackageText = '';
    this.shootingAngle = '';
    this.grp_ShootingAngle = '';
    this.alignment = '';
    this.grp_Alignment = '';
    this.alignmentHorizontal = '';
    this.alignmentVertical = '';
    this.vesselPlating = '';
    this.grp_VesselPlating = '';
    this.plating = '';
    this.grp_Plating = '';
    this.accompaniments = '';
    this.grp_Accompaniments = '';
    this.qtyCookNecessary = '';
    this.grp_QtyCookNecessary = '';
    this.qtyCookNecessaryNum = '';
    this.qtyCookNecessaryVesselNum = '';
    this.vesselShapeCookNecessary = '';
    this.grp_VesselShapeCookNecessary = '';
    this.vesselCookNecessary = '';
    this.grp_VesselCookNecessary = '';
    this.photoImageCookNecessary = '';
    this.grp_PhotoImageCookNecessary = '';
    this.photoRenditionCookNecessary = '';
    this.grp_PhotoRenditionCookNecessary = '';
    this.qtyCookUnnecessary = '';
    this.grp_QtyCookUnnecessary = '';
    this.qtyCookUnnecessaryNum = '';
    this.qtyCookUnnecessaryVesselNum = '';
    this.vesselShapeCookUnnecessary = '';
    this.grp_VesselShapeCookUnnecessary = '';
    this.vesselCookUnnecessary = '';
    this.grp_VesselCookUnnecessary = '';
    this.photoImageCookUnnecessary = '';
    this.grp_PhotoImageCookUnnecessary = '';
    this.cropExistenceType = '';
    this.grp_CropExistenceType1 = '';
    this.grp_CropExistenceType2 = '';
    this.shootingPackageTextEnabled = false;
    this.alignmentHorizontalEnabled = false;
    this.alignmentVerticalEnabled = false;
    this.qtyCookNecessaryNumEnabled = false;
    this.qtyCookNecessaryVesselNumEnabled = false;
    this.qtyCookUnnecessaryNumEnabled = false;
    this.qtyCookUnnecessaryVesselNumEnabled = false;
    this.referenceImageList = new Array<ReferenceImageList>();

    // 変更フラグ初期化
    this.changeDetailFlg = false;
  }

  /* 撮影注意事項をクリアする */
  public clearPhotoCaution(): void {
    this.photoInstructContents = '';
    this.imageTypeStatusVisible = '';
    this.colorChange = '';
    this.crossSection = false;
    this.photoRenditionCookUnnecessary = false;
    this.shooting = '';
    this.grp_Shooting = '';
    this.shootingPackageText = '';
    this.shootingAngle = '';
    this.grp_ShootingAngle = '';
    this.alignment = '';
    this.grp_Alignment = '';
    this.alignmentHorizontal = '';
    this.alignmentVertical = '';
    this.vesselPlating = '';
    this.grp_VesselPlating = '';
    this.plating = '';
    this.grp_Plating = '';
    this.accompaniments = '';
    this.grp_Accompaniments = '';
    this.qtyCookNecessary = '';
    this.grp_QtyCookNecessary = '';
    this.qtyCookNecessaryNum = '';
    this.qtyCookNecessaryVesselNum = '';
    this.vesselShapeCookNecessary = '';
    this.grp_VesselShapeCookNecessary = '';
    this.vesselCookNecessary = '';
    this.grp_VesselCookNecessary = '';
    this.photoImageCookNecessary = '';
    this.grp_PhotoImageCookNecessary = '';
    this.photoRenditionCookNecessary = '';
    this.grp_PhotoRenditionCookNecessary = '';
    this.qtyCookUnnecessary = '';
    this.grp_QtyCookUnnecessary = '';
    this.qtyCookUnnecessaryNum = '';
    this.qtyCookUnnecessaryVesselNum = '';
    this.vesselShapeCookUnnecessary = '';
    this.grp_VesselShapeCookUnnecessary = '';
    this.vesselCookUnnecessary = '';
    this.grp_VesselCookUnnecessary = '';
    this.photoImageCookUnnecessary = '';
    this.grp_PhotoImageCookUnnecessary = '';
    this.cropExistenceType = '';
    this.grp_CropExistenceType1 = '';
    this.grp_CropExistenceType2 = '';
    this.shootingPackageTextEnabled = false;
    this.alignmentHorizontalEnabled = false;
    this.alignmentVerticalEnabled = false;
    this.qtyCookNecessaryNumEnabled = false;
    this.qtyCookNecessaryVesselNumEnabled = false;
    this.qtyCookUnnecessaryNumEnabled = false;
    this.qtyCookUnnecessaryVesselNumEnabled = false;

    // 変更フラグ初期化
    this.changeDetailFlg = false;
  }

  /**
   * referenceImageFileUpload用のVOを返却する
   *
   * @return referenceImageFileUploadVO
   */
  public getReferenceImageFileUploadVO(fileRef: any): any {
    const vo = {
      fileRef: fileRef,
    };
    return vo;
  }

}
